import React, { Component, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { PropTypes } from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import * as S from './styles';

const zones = {
  left: '#modal-left-root',
  right: '#modal-right-root',
  whole: '#modal-root',
};

const PopUpView = ({
  isOpen,
  children,
  zone,
  onClose,
  className,
  fullWidth,
}) => {
  const [render, setRender] = useState(isOpen);

  useEffect(() => {
    if (isOpen) setRender(true);
  }, [isOpen]);

  const onAnimationEnd = () => {
    if (!isOpen) setRender(false);
  };

  const handleClose = () => {
    if (render && isOpen) {
      onClose();
    }
  };

  const refContainer = document.querySelector(zones[zone]) || document.body;

  if (refContainer && render) {
    return ReactDOM.createPortal(
      <>
        <S.OpacityLayer zone={zone} />
        <PopUpContainer
          eventTypes={['click']}
          animation={isOpen ? 'open' : 'close'}
          onAnimationEnd={onAnimationEnd}
          zone={zone}
          onClose={() => {
            handleClose();
          }}
          className={className}
          fullWidth={fullWidth}
        >
          {children}
        </PopUpContainer>
      </>,
      refContainer
    );
  }
  return null;
};

PopUpView.propTypes = {
  isOpen: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.bool,
  ]),
  zone: PropTypes.string,
  onClose: PropTypes.func,
  className: PropTypes.string,
};

PopUpView.defaultProps = {
  isOpen: false,
  zone: 'left',
  onClose: () => {},
  className: '',
};

class RenderPopUpContainer extends Component {
  handleClickOutside = evt => {
    evt.preventDefault();
    evt.stopPropagation();
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { children, ...rest } = this.props;
    return <S.Container {...rest}>{children}</S.Container>;
  }
}

RenderPopUpContainer.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

const clickOutsideConfig = {
  stopPropagation: true,
};

const PopUpContainer = onClickOutside(RenderPopUpContainer, clickOutsideConfig);

export default PopUpView;
